module.exports = __webpack_public_path__ + "img/item_link_engraving@2x.27d2a36.jpg";